import * as tslib_1 from "tslib";
import { memoize, parseFieldSpecs } from '@fullcalendar/core';
import { AbstractTimeGridView, buildDayTable as buildAgendaDayTable } from '@fullcalendar/timegrid';
import { ResourceDayHeader, ResourceDayTable, DayResourceTable, flattenResources } from '@fullcalendar/resource-common';
import { ResourceDayGrid } from '@fullcalendar/resource-daygrid';
import ResourceTimeGrid from './ResourceTimeGrid';
var ResourceTimeGridView = /** @class */ (function (_super) {
    tslib_1.__extends(ResourceTimeGridView, _super);
    function ResourceTimeGridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processOptions = memoize(_this._processOptions);
        _this.flattenResources = memoize(flattenResources);
        _this.buildResourceDayTable = memoize(buildResourceDayTable);
        return _this;
    }
    ResourceTimeGridView.prototype._processOptions = function (options) {
        this.resourceOrderSpecs = parseFieldSpecs(options.resourceOrder);
    };
    ResourceTimeGridView.prototype.render = function (props, context) {
        _super.prototype.render.call(this, props, context); // for flags for updateSize. and will call _renderSkeleton/_unrenderSkeleton
        var options = context.options, nextDayThreshold = context.nextDayThreshold;
        this.processOptions(options);
        var splitProps = this.splitter.splitProps(props);
        var resources = this.flattenResources(props.resourceStore, this.resourceOrderSpecs);
        var resourceDayTable = this.buildResourceDayTable(props.dateProfile, props.dateProfileGenerator, resources, options.datesAboveResources);
        if (this.header) {
            this.header.receiveProps({
                resources: resources,
                dates: resourceDayTable.dayTable.headerDates,
                dateProfile: props.dateProfile,
                datesRepDistinctDays: true,
                renderIntroHtml: this.renderHeadIntroHtml
            }, context);
        }
        this.resourceTimeGrid.receiveProps(tslib_1.__assign({}, splitProps['timed'], { dateProfile: props.dateProfile, resourceDayTable: resourceDayTable }), context);
        if (this.resourceDayGrid) {
            this.resourceDayGrid.receiveProps(tslib_1.__assign({}, splitProps['allDay'], { dateProfile: props.dateProfile, resourceDayTable: resourceDayTable, isRigid: false, nextDayThreshold: nextDayThreshold }), context);
        }
        this.startNowIndicator(props.dateProfile, props.dateProfileGenerator);
    };
    ResourceTimeGridView.prototype._renderSkeleton = function (context) {
        _super.prototype._renderSkeleton.call(this, context);
        if (context.options.columnHeader) {
            this.header = new ResourceDayHeader(this.el.querySelector('.fc-head-container'));
        }
        this.resourceTimeGrid = new ResourceTimeGrid(this.timeGrid);
        if (this.dayGrid) {
            this.resourceDayGrid = new ResourceDayGrid(this.dayGrid);
        }
    };
    ResourceTimeGridView.prototype._unrenderSkeleton = function () {
        _super.prototype._unrenderSkeleton.call(this);
        if (this.header) {
            this.header.destroy();
        }
        this.resourceTimeGrid.destroy();
        if (this.resourceDayGrid) {
            this.resourceDayGrid.destroy();
        }
    };
    ResourceTimeGridView.prototype.renderNowIndicator = function (date) {
        this.resourceTimeGrid.renderNowIndicator(date);
    };
    ResourceTimeGridView.needsResourceData = true; // for ResourceViewProps
    return ResourceTimeGridView;
}(AbstractTimeGridView));
export default ResourceTimeGridView;
function buildResourceDayTable(dateProfile, dateProfileGenerator, resources, datesAboveResources) {
    var dayTable = buildAgendaDayTable(dateProfile, dateProfileGenerator);
    return datesAboveResources ?
        new DayResourceTable(dayTable, resources) :
        new ResourceDayTable(dayTable, resources);
}
